import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modify_results';
export const route = 'modify_results/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modify_results" */
/* webpackPrefetch: true */
'../components/ResultsPage')));